// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Jl6hT","fieldset":"Form_fieldset__5Iu-0","legend":"Form_legend__roxuG","checkboxList":"Form_checkboxList__WfIo3"};